import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Clients from "@/components/Clients";
import Services from "@/components/Services";
import QuoteForm from "@/components/QuoteForm";
import WhyChooseUs from "@/components/WhyChooseUs";
import Portfolio from "@/components/Portfolio";
import Process from "@/components/Process";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Preloader } from "@/components/Preloader";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#0A0A0A] text-white min-h-screen">
      <Toaster position="top-center" richColors />
      <Preloader />
      <Navbar />
      <main>
        <Hero />
        <Clients />
        <Services />
        <Marquee />
        <WhyChooseUs />
        <Portfolio />
        <Process />
        <About />
        <Contact />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
